// @ts-nocheck
import React, { PropsWithChildren, } from 'react';
import clsx from 'clsx';
import { makeStyles, } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import useFetch from '../../hooks/useFetch';
import { ROLE_ENUM, } from '../../request/enums';

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
	},
	appBar: {
		transition: theme.transitions.create([
			'margin', 'width',
		], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		}),
	},
	appBarShift: {
		width: `calc(100% - ${drawerWidth}px)`,
		marginLeft: drawerWidth,
		transition: theme.transitions.create([
			'margin', 'width',
		], {
			easing: theme.transitions.easing.easeOut,
			duration: theme.transitions.duration.enteringScreen,
		}),
	},
	menuButton: {
		marginRight: theme.spacing(2),
	},
	hide: {
		display: 'none',
	},
	drawer: {
		width: drawerWidth,
		flexShrink: 0,
	},
	drawerPaper: {
		width: drawerWidth,
	},
	drawerHeader: {
		display: 'flex',
		alignItems: 'center',
		padding: theme.spacing(0, 1),
		// necessary for content to be below app bar
		...theme.mixins.toolbar,
		justifyContent: 'flex-end',
	},
	content: {
		flexGrow: 1,
		padding: theme.spacing(3),
		transition: theme.transitions.create('margin', {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		}),
		marginLeft: -drawerWidth,
	},
	contentShift: {
		transition: theme.transitions.create('margin', {
			easing: theme.transitions.easing.easeOut,
			duration: theme.transitions.duration.enteringScreen,
		}),
		marginLeft: 0,
	},
}));

export default function PersistentDrawerLeft(props: PropsWithChildren<any>) {
	const {
		children,
	} = props;
	const classes = useStyles();

	const {
		data,
		isDataLoading,
	} = useFetch<any>({
		url: 'user',
		method: 'GET',
	});

	if (!data || isDataLoading) {
		return <></>;
	}

	const {
		authorities,
	} = data;

	return (
		<div className={classes.root}>
			<CssBaseline />
			<AppBar
				position="fixed"
				className={clsx(classes.appBar, {
					[classes.appBarShift]: false,
				})}
			>
				<Toolbar className="sm:flex sm:flex-col">
					<a href="/">
						<Typography variant="h6" noWrap>
							Old Mouse Admin
						</Typography>
					</a>

					<div className={'flex flex-row sm:flex-col ml-10 sm:ml-0'}>
						{authorities?.map(item =>
							<div>
								{item?.authority === ROLE_ENUM.ACTOR &&
									<a href={'/employee'} className={'px-4 flex items-center sm:justify-center uppercase font-bold hover:opacity-50'} button key={item.authority}>
										Сотрудник
									</a>
								}

								{item?.authority === ROLE_ENUM.MANAGER &&
									<a href={'/manager'} className={'px-4 flex items-center sm:justify-center uppercase font-bold hover:opacity-50'} button key={item.authority}>
										Менеджер
									</a>
								}

								{item?.authority === ROLE_ENUM.ADMIN &&
									<a href={'/admin'} className={'px-4 flex items-center sm:justify-center uppercase font-bold hover:opacity-50'} button key={item.authority}>
										Администратор
									</a>
								}
							</div>
						)}
					</div>
				</Toolbar>
			</AppBar>
			<Drawer
				className={classes.drawer}
				variant="persistent"
				anchor="left"
				open={false}
				classes={{
					paper: classes.drawerPaper,
				}}
			/>

			<main className={`${clsx(classes.content, {
				[classes.contentShift]: false,
			})} h-full`}>
				<div className={classes.drawerHeader} />
				{children}
			</main>
		</div>
	);
}
